import React from 'react';
import { cloneChildrenWithProps } from '../../../jsCore/utils/reactUtils';

export const FanvoiceItem = ({ blockName, modifier, itemData, children }) => {
  const className = `${blockName}__link`;
  const { link } = itemData;
  return (
     <a href={ link } target="_blank"
       className={ `${className} ${className}--${modifier}` }
       data-analytics-event-category="Home page"
       data-analytics-event-action="fanvoice section click"
       data-analytics-event-label={ modifier }
     >
      { cloneChildrenWithProps(children, { blockName, modifier }) }
     </a>
  );
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fanvoice/components/fanvoiceItem.js